<puro-footer
  class="app-shell__footer-kit"
  [language]="language()"
  [languages]="languages()"
  [legalLinks]="legalLinks()"
  [copyrightText]="copyrightText()"
  (languageChange)="languageChange.emit($event)"
/>
